import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy-darker text-gray-300">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_e4501b70-3916-4f5c-9cb2-b91d80cef241/artifacts/ywaw69v6_Main%20Circle%20Cut.png"
              alt="Savior Windows Logo"
              className="h-16 w-auto mb-4 brightness-110"
              style={{ mixBlendMode: 'lighten' }}
            />
            <p className="text-sm leading-relaxed mb-4">
              Colorado's trusted window and door replacement experts with over 10 years of excellence serving homeowners across the Front Range.
            </p>
            <p className="text-gold font-semibold text-sm mb-4">
              Excellence Meets Affordability®
            </p>
            <div className="flex gap-3">
              <a 
                href="https://www.facebook.com/profile.php?id=61586173917757"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gold/10 hover:bg-gold/20 rounded-lg flex items-center justify-center text-gold hover:text-gold-light transition-all duration-200 transform hover:scale-110"
                aria-label="Visit our Facebook page"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4 border-b border-gold/30 pb-2">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-gold transition-colors inline-block">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-gold transition-colors inline-block">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/financing" className="text-sm hover:text-gold transition-colors inline-block">
                  Financing Options
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-gold transition-colors inline-block">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-gold transition-colors inline-block">
                  Free Estimate
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4 border-b border-gold/30 pb-2">
              Contact
            </h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href={`tel:${contactInfo.phoneRaw}`}
                  className="flex items-start gap-2 text-sm hover:text-gold transition-colors group"
                >
                  <Phone size={16} className="mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                  <span>{contactInfo.phone}</span>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-start gap-2 text-sm hover:text-gold transition-colors group"
                >
                  <Mail size={16} className="mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                  <span className="break-all">{contactInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                <span>
                  {contactInfo.address}<br />
                  {contactInfo.city}, {contactInfo.state} {contactInfo.zip}
                </span>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4 border-b border-gold/30 pb-2">
              Business Hours
            </h3>
            <div className="space-y-2 text-sm">
              <div className="flex items-start gap-2">
                <Clock size={16} className="mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white">{contactInfo.hours.weekday}</p>
                  <p className="mt-1">{contactInfo.hours.saturday}</p>
                  <p className="mt-1">{contactInfo.hours.sunday}</p>
                </div>
              </div>
            </div>
            <div className="mt-6 p-4 bg-gold/10 border border-gold/30 rounded-lg">
              <p className="text-xs text-gold font-semibold mb-1">Emergency Service Available</p>
              <p className="text-xs">24/7 for urgent repairs</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gold/20 bg-navy-darkest">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p className="text-gray-400">
              © {currentYear} Savior Replacement Windows & Doors, LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a 
                href="https://www.facebook.com/profile.php?id=61586173917757"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gold transition-colors flex items-center gap-2"
              >
                <Facebook size={18} />
                <span>Follow Us</span>
              </a>
              <a href="#" className="text-gray-400 hover:text-gold transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-gold transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
